export default __webpack_public_path__ + "static/media/bg.faa8230d.svg";